// Routes
import Comment from './Comment'
import Login from './Login'
import Signup from './Signup'

const route = 'signup'

const routes = {
  login: Login,
  signup: Signup,
  comment: Comment,
}

export { route, routes }
